import { useQuery } from "./urqlHooks";

const _AREADETAIL = `query AreaDetail(
    $companyId: String!
    $cashflowAreaId: String!
    $startDate: DateTime!
    $endDate: DateTime!
    $useDelayed: Boolean!
    $currencyType: SupportedCurrency,
    $isOld: Boolean,
  ) {
    AreaDetail(
      companyId: $companyId
      cashflowAreaId: $cashflowAreaId
      startDate: $startDate
      endDate: $endDate
      useDelayed: $useDelayed
      currencyType: $currencyType
      isOld: $isOld
    ) {
      startDate
      endDate
      settledPoints {
        count
        total
      }
      delayedPoints {
        count
        total
      }
      regularPoints {
        count
        total
      }
    }
  }`;

// export const GetAreaDetail = (
//   companyId,
//   cashflowAreaId,
//   startDate,
//   endDate,
//   useDelayed,
//   currencyType,
//   isOld
// ) => {
//   const [detailResult, reExecuteQuery] = useQuery({
//     query: AREADETAIL,
//     variables: {
//       companyId,
//       cashflowAreaId,
//       startDate,
//       endDate,
//       useDelayed,
//       currencyType,
//       isOld,
//     },
//   });
//   const { data, fetching, error } = detailResult;
//   return { data, fetching, error, reExecuteQuery };
// };

const DELAYEDPOINTSDETAIL = `query DelayedPointsDetail($companyId: String!, $cashflowAreaId: String!, $startDate: DateTime!, $endDate: DateTime!, $useDelayed: Boolean!) {
  AreaDetail(companyId: $companyId, cashflowAreaId: $cashflowAreaId, startDate: $startDate, endDate: $endDate, useDelayed: $useDelayed) {
    delayedPoints {
      ...ResolvedPointsFragment
    }
  }
}
fragment ResolvedPointsFragment on ResolvedPoints {
  points {
    id
    date
    amount
    amountBeforeFactorized
    amountBeforePartialPayoff
    currencyType
    settled
    documentType
    documentId
    document {
      documentDate
      name
      description
      cashflowArea {
        id
        name
      }
      company {
        name
        __typename
      }
      meta {
        ... on TaxDocumentMeta {
          documentId
          isReceived
          issuerName
          receiverName
          issuerId
          receiverId
          documentCode
          __typename
        }
        ... on InitialBalanceMeta {
          initialBalance
        }
        ... on ManualMeta {
          repeating
          interval
          until
          documentId
          pago
          counterpartName
          counterpartRut
        }
        ... on CreditsMeta {
          totalPayments
          paymentNumber
          identificator
        }
        ... on ObligationMeta {
          isReceived
          issuerName
          receiverName
          typeLabel
          number
        }
      }
    }
  }
}`;

export const GetDelayedPointDetail = (
  companyId,
  cashflowAreaId,
  startDate,
  endDate,
  useDelayed
) => {
  const [delayedPoints, reExecuteQuery] = useQuery({
    query: DELAYEDPOINTSDETAIL,
    variables: {
      companyId,
      cashflowAreaId,
      startDate,
      endDate,
      useDelayed,
    },
  });
  const { data, fetching, error } = delayedPoints;
  return { data, fetching, error, reExecuteQuery };
};

const SETTLEDPOINTSDETAIL = `query SettledPointsDetail($companyId: String!, $cashflowAreaId: String!, $startDate: DateTime!, $endDate: DateTime!, $useDelayed: Boolean!, $isOld: Boolean) {
  AreaDetail(companyId: $companyId, cashflowAreaId: $cashflowAreaId, startDate: $startDate, endDate: $endDate, useDelayed: $useDelayed, isOld: $isOld) {
    settledPoints {
      ...ResolvedPointsFragment
      __typename
    }
    __typename
  }
}
fragment ResolvedPointsFragment on ResolvedPoints {
  points {
    id
    date
    amount
    originalAmount
    amountBeforeFactorized
    amountBeforePartialPayoff
    currencyType
    settled
    documentType
    documentId
    document {
      documentDate
      name
      description
      cashflowArea {
        id
        name
      }
      company {
        name
        __typename
      }
      meta {
        ... on TaxDocumentMeta {
          documentId
          isReceived
          issuerName
          receiverName
          issuerId
          receiverId
          documentCode
          __typename
        }
        ... on InitialBalanceMeta {
          initialBalance
          __typename
        }
        ... on ManualMeta {
          repeating
          interval
          until
          documentId
          pago
          counterpartName
          counterpartRut
          __typename
        }
        ... on CreditsMeta {
          totalPayments
          paymentNumber
          identificator
          __typename
        }
        ... on ObligationMeta {
          isReceived
          issuerName
          receiverName
          typeLabel
          number
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}`;

export const GetSettledPointsDetail = (
  companyId,
  cashflowAreaId,
  startDate,
  endDate,
  useDelayed,
  isOld,
) => {
  const [settledPointsDetail, reExecuteQuery] = useQuery({
    query: SETTLEDPOINTSDETAIL,
    variables: {
      companyId,
      cashflowAreaId,
      startDate,
      endDate,
      useDelayed,
      isOld,
    },
  });
  const { data, fetching, error } = settledPointsDetail;
  return { data, fetching, error, reExecuteQuery };
};

const REGULARPOINTSDETAIL = `query RegularPointsDetail($companyId: String!, $cashflowAreaId: String!, $startDate: DateTime!, $endDate: DateTime!, $useDelayed: Boolean!) {
  AreaDetail(companyId: $companyId, cashflowAreaId: $cashflowAreaId, startDate: $startDate, endDate: $endDate, useDelayed: $useDelayed) {
    regularPoints {
      ...ResolvedPointsFragment
      __typename
    }
    __typename
  }
}
fragment ResolvedPointsFragment on ResolvedPoints {
  points {
    id
    date
    amount
    amountCLP
    amountBeforeFactorized
    amountBeforePartialPayoff
    currencyType
    settled
    documentType
    documentId
    document {
      documentDate
      name
      description
      emissionDate
      cashflowArea {
        id
        name
      }
      company {
        name
        __typename
      }
      meta {
        ... on TaxDocumentMeta {
          documentId
          isReceived
          issuerName
          receiverName
          issuerId
          receiverId
          documentCode
          __typename
        }
        ... on InitialBalanceMeta {
          initialBalance
          __typename
        }
        ... on ManualMeta {
          repeating
          interval
          until
          documentId
          pago
          counterpartName
          counterpartRut
          __typename
        }
        ... on CreditsMeta {
          totalPayments
          paymentNumber
          identificator
          __typename
        }
        ... on ObligationMeta {
          isReceived
          issuerName
          receiverName
          number
          typeLabel
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}`;

export const GetRegularPointsDetail = (
  companyId,
  cashflowAreaId,
  startDate,
  endDate,
  useDelayed
) => {
  const [regularPointsDetail, reExecuteQuery] = useQuery({
    query: REGULARPOINTSDETAIL,
    variables: {
      companyId,
      cashflowAreaId,
      startDate,
      endDate,
      useDelayed,
    },
  });
  const { data, fetching, error } = regularPointsDetail;
  return { data, fetching, error, reExecuteQuery };
};
